"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sizeListener = void 0;
exports.prepareSetWindowDimensions = prepareSetWindowDimensions;
var rxjs_1 = require("rxjs");
var viewport_1 = require("../actions/viewport");
function generateEventListener(mql, cb) {
    if (mql.addEventListener) {
        mql.addEventListener('change', cb);
    }
    else {
        ;
        mql.addListener(cb);
    }
}
exports.sizeListener = new rxjs_1.Observable(function (observer) {
    var mobile = window.matchMedia('screen and (max-width: 600px)');
    generateEventListener(mobile, function (e) {
        if (e.matches) {
            observer.next((0, viewport_1.setSize)('MOBILE'));
        }
    });
    var tablet = window.matchMedia('screen and (min-width: 600px) and (max-width: 979px)');
    generateEventListener(tablet, function (e) {
        if (e.matches) {
            observer.next((0, viewport_1.setSize)('TABLET'));
        }
    });
    var desktop = window.matchMedia('screen and (min-width: 980px)');
    generateEventListener(desktop, function (e) {
        if (e.matches) {
            observer.next((0, viewport_1.setSize)('DESKTOP'));
        }
    });
    if (mobile.matches) {
        observer.next((0, viewport_1.setSize)('MOBILE'));
    }
    if (tablet.matches) {
        observer.next((0, viewport_1.setSize)('TABLET'));
    }
    if (desktop.matches) {
        observer.next((0, viewport_1.setSize)('DESKTOP'));
    }
});
function prepareSetWindowDimensions() {
    return exports.sizeListener;
}
